import { Pipe, PipeTransform } from '@angular/core';
import { numberToString } from '@shared/numbers';

@Pipe({
  name: 'dashboardCurrency'
})
export class DashboardCurrencyPipe implements PipeTransform {
  transform(input: any, args?: any): any {
    return numberToString(input, args);
  }
}
